<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {};
</script>


<style lang="less">
#app {
  // overflow: hidden;
  // overflow: auto;
  /*loading样式*/
  .loader {
    opacity: 0.8;
    z-index: 1500;
  }

  .ivu-loading-bar {
    z-index: 1500;
  }

  .demo-spin-icon-load {
    animation: ani-demo-spin 1s linear infinite;
  }

  @keyframes ani-demo-spin {
    from {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(180deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  /*loading样式 END*/

  /*不换行*/
  .nowrap {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  /*不换行 END*/

  /*防止table超过之后不出现滚动条*/
  .ivu-table-body {
    overflow-y: auto;
    overflow-x: hidden;
  }
  /*防止table超过之后不出现滚动条 END*/
}

/*图标垂直居中*/
.help .ivu-icon {
  vertical-align: middle;
}
/*图标垂直居中 END*/

/*图片上传本地预览的样式 END*/

/*修改iview默认的select取消按钮的颜色*/
.ivu-icon-ios-close:before {
  color: #ed3f14;
}
/*修改iview默认的select取消按钮的颜色 END*/

/*去掉所有修改时的模态框底部的线*/
body .ivu-modal-footer {
  border-top: none;
}
/*去掉所有修改时的模态框底部的线 END*/

/*模态框标题居中*/
.modal-title-center {
  text-align: center;
}
/*模态框标题居中 END*/

/*模态框居中*/
.vertical-middle-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  .ivu-modal {
    top: 0;
  }
}
/*模态框居中 END*/

/*长度为180px的select*/
.ivu-select.v-mSelect {
  width: 180px;
}
/*长度为180px的select END*/
.leftNavigation {
  height: 100%;
}
.ivu-upload-list {
  display: none;
}
  .ivu-form-item-error-tip{
      width:120px !important;
  }
</style>
